import { Col, Container, Form, Row } from "react-bootstrap";
import { useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { REGEX } from "../../utils/utils";
import { connect } from "react-redux";
import { PermissionContext } from "../../../../hooks/PermissionContext"

const defaultValues = {
  productName: "",
  abbreviation: "",
  productDescription: "",
  sku: "",
  masterSku: ""
};

const ProductIdentityFormComponent = ({
  rowEdited = null
}) => {
  const { hasPermission } = useContext(PermissionContext);

  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext({
    defaultValues: defaultValues,
  });

  useEffect(() => {
    if (!rowEdited) return;
    setValue("productName", rowEdited.name || "");
    setValue("abbreviation", rowEdited.abbreviation || "");
    setValue("productDescription", rowEdited.description || "");
    setValue("sku", rowEdited.sku || "");
    setValue("barcode", rowEdited.barcode || "");
    setValue("masterSku", rowEdited.masterSku || "");
  }, [rowEdited]);

  return (
    <Container>
      <h4>Identificación del producto</h4>
      <hr />
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="productName" className="form-label">
            Nombre del producto <span className="text-danger">*</span>
          </label>
          <input
            {...register("productName", {
              required: "El nombre del producto es obligatorio",
              minLength: {
                value: 3,
                message: "Mínimo 3 caracteres",
              },
              maxLength: {
                value: 100,
                message: "Máximo 100 caracteres",
              }
            })}
            id="productName"
            type="text"
            placeholder="Nombre comercial"
            className={`form-control ${!!errors?.productName && "is-invalid"}`}
          />
          {!!errors?.productName && (
            <span className="error-message">
              {errors?.productName?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="abbreviation" className="form-label">
            Abreviatura <span className="text-danger">*</span>
          </label>
          <input
            {...register("abbreviation", {
              required: "La abreviatura es obligatoria",
              maxLength: {
                value: 10,
                message: "Máximo 10 caracteres",
              }
            })}
            id="abbreviation"
            type="text"
            placeholder="PROD01"
            className={`form-control ${!!errors?.abbreviation && "is-invalid"}`}
          />
          {!!errors?.abbreviation && (
            <span className="error-message">
              {errors?.abbreviation?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="productDescription" className="form-label">
            Descripción del producto <span className="text-danger">*</span>
          </label>
          <textarea
            {...register("productDescription", {
              required: "La descripción del producto es obligatorio",
              maxLength: {
                value: 100,
                message: "Máximo 100 caracteres",
              },
            })}
            id="productDescription"
            type="text"
            placeholder="Descripción breve del producto"
            className={`form-control ${!!errors?.productDescription && "is-invalid"}`}
          />
          {!!errors?.productDescription && (
            <span className="error-message">
              {errors?.productDescription?.message ||
                "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="sku" className="form-label">
            ID Externo (SKU)
          </label>
          <input
            {...register("sku", {
              maxLength: {
                value: 30,
                message: "Máximo 30 caracteres",
              }
            })}
            id="sku"
            type="text"
            placeholder="Código del remitente"
            className={`form-control ${!!errors?.sku && "is-invalid"}`}
            disabled={rowEdited?.sku}
          />
          {!!errors?.sku && (
            <span className="error-message">
              {errors?.sku?.message || "Este campo no cumple las condiciones"}
            </span>
          )}
        </Form.Group>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="barcode" className="form-label">
            Código de barras
          </label>
          <input
            {...register("barcode", {
              maxLength: {
                value: 14,
                message: "Máximo 14 caracteres",
              }
            })}
            id="barcode"
            type="text"
            placeholder="Código del remitente"
            className={`form-control ${!!errors?.barcode && "is-invalid"}`}
            disabled={rowEdited?.barcode && !hasPermission('feature:change-product-barcode')}
          />
          {!!errors?.barcode && (
            <span className="error-message">
              {errors?.barcode?.message || "Este campo no cumple las condiciones"}
            </span>
          )}
        </Form.Group>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="masterSku" className="form-label">
            Item master
          </label>
          <input
            {...register("masterSku", {
              maxLength: {
                value: 30,
                message: "Máximo 30 caracteres",
              },
              pattern: {
                value: REGEX.ALPHANUMERIC,
                message: "Solo se permiten letras y números",
              },
            })}
            id="masterSku"
            type="text"
            placeholder="Agrupador de SKUs"
            className={`form-control ${!!errors?.masterSku && "is-invalid"}`}
          />
          {!!errors?.masterSku && (
            <span className="error-message">
              {errors?.masterSku?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>

    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    rowEdited: state.productState.rowEdited,
  };
};

export const ProductIdentityForm = connect(
  mapStateToProps,
)(ProductIdentityFormComponent);
